import { registerMockAPI } from '~/mocks/mockApis';

import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import type { TypeGetInboundRequestProgressRequestIdResponse } from '~/types/receive.types';

type TypeFetchInboundRequestProgressByRequestIdParams = {
  ownerCode: string;
  requestId: string;
};

const fetchInboundRequestProgressByRequestId = async ({
  ownerCode,
  requestId,
}: TypeFetchInboundRequestProgressByRequestIdParams): Promise<TypeGetInboundRequestProgressRequestIdResponse> => {
  const { data } = await axiosInstance.get<TypeGetInboundRequestProgressRequestIdResponse>(
    `/api-inbound/v1/3pl/receiving/${ownerCode}/inbound-request/progress/${requestId}`
  );
  return data;
};

/**
 * [입고관리 > 입고현황] 3PL 입고현황 상세 조회 Mutation Hook
 */
export const useGetInboundRequestProgressByRequestIdMutation = () => {
  return useMutation({
    mutationFn: fetchInboundRequestProgressByRequestId,
  });
};

// 정상 응답에 reportStatus REGISTERED + reports 2건 + reportProgressCount 부분 처리 + items status 혼합
const normal3PLDetailResponse: TypeGetInboundRequestProgressRequestIdResponse = {
  data: {
    summary: {
      status: 'PROCEEDING',
      requestCode: 'OR20260513_3PL_00001',
      requestDate: '2026.05.10',
      estimatedArrivalDate: '2026.05.13',
      estimatedArrivalTime: '10:00~12:00',
      finalEstimatedArrivalDate: '2026.05.13~2026.05.13',
      receivingClusterName: '평택센터',
      receivingWarehouseName: '평택상온',
      supplierName: '테스트 화주사_첫번째 공급사',
      supplierCode: 'SU000004',
      releaseCodeName: '컬리배차(직배송)',
      xdock: 'N',
      reportStatus: 'REGISTERED',
      reports: [
        { reportId: 5001, reportCode: 'RP20260513_00001' },
        { reportId: 5002, reportCode: 'RP20260513_00002' },
      ],
    },
    progressCount: {
      totalReceivedQty: 72,
      totalRequestedQty: 120,
      receivedSku: 3,
      requestedSku: 5,
    },
    reportProgressCount: {
      totalQty: 10,
      completedQty: 6,
      incompleteQty: 4,
    },
    items: [
      {
        seq: 1,
        status: 'COMPLETED',
        goodsCode: 'EN0000010151',
        goodsName: '닥터유 단백질 35g(3PL)',
        requestedQty: 40,
        receivedQty: 40,
        receivedDate: '2026-05-13T10:30:00',
      },
      {
        seq: 2,
        status: 'PROCEEDING',
        goodsCode: 'EN0000010152',
        goodsName: '닥터유 단백질 40g(3PL)',
        requestedQty: 50,
        receivedQty: 32,
        receivedDate: '2026-05-13T11:00:00',
      },
      {
        seq: 3,
        status: 'WAITING',
        goodsCode: 'EN0000010153',
        goodsName: '닥터유 단백질 45g(3PL)',
        requestedQty: 30,
        receivedQty: 0,
        receivedDate: '',
      },
    ],
  },
};

registerMockAPI<TypeGetInboundRequestProgressRequestIdResponse>({
  method: 'get',
  endpoint: '/api-inbound/v1/3pl/receiving/:ownerCode/inbound-request/progress/:requestId',
  label: '입고/입고현황3PL/상세',
  scenarios: [
    {
      name: '정상 응답 — reports 2건 + 부분 처리 + items status 혼합',
      response: normal3PLDetailResponse,
    },
    {
      name: '잘못된 파라미터 (9001)',
      response: { error: { code: 9001, message: 'Error Occured By Not Valid Parameters' } },
      status: 400,
    },
  ],
});
